import React from 'react';
import OnVisible from 'react-on-visible';
import { Image, RestaurantSignUp, StoreBadges } from '../components';
import './Hero.scss';

export const Hero = props => {
  const { data } = props;
  const { primary } = data;
  const { background_image: backgroundImage, title, content, show_app_store_links: showStoreLinks } = primary;
  const storeBadges = showStoreLinks === 'Yes';
  const signUp = showStoreLinks === 'Yes (Partners App)';
  return (
    <OnVisible className="hero">
      <Image image={backgroundImage} />
      <div className="wrapper">
        <div className="hero-body">
          {title && <h2 className="hero-body-title">{title.text}</h2>}
          <div className="hero-body-content" dangerouslySetInnerHTML={{ __html: content.html }} />
          {storeBadges && <StoreBadges restaurantAppLinks={showStoreLinks === 'Yes (Partners App)'} />}
          {signUp && <RestaurantSignUp />}
          {signUp && <StoreBadges restaurantAppLinks />}
        </div>
      </div>
    </OnVisible>
  );
};
